import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
import type { IMediaLibUploadingFile } from "../types";

interface IState {
  uploadingFiles: IMediaLibUploadingFile[];
}

interface IActions {
  setUploadingFiles: (value: IMediaLibUploadingFile[]) => void;
  reset: () => void;
}

const initState: IState = {
  uploadingFiles: [],
};

export const useMediaLibUploadingStore = create<IState & IActions>((set) => ({
  ...initState,
  setUploadingFiles: (uploadingFiles) => set({ uploadingFiles }),
  reset: () => set(initState),
}));

export const useMediaLibUploadingStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => {
  return useMediaLibUploadingStore(useShallow(selector));
};
